import { configuration } from 'src/configuration';
import { Cohort } from 'src/types/cohorts';
import { get, patch } from 'src/utils/fetch';
import { to } from 'to-await';

const { accountApiUrl } = configuration;
const DATA_SOURCE_BASE_URL = `${accountApiUrl}/data-sources`;

export const getCohortsbyDataSourceId = async ({
  token,
  dataSourceId,
}: {
  token: string;
  dataSourceId: string;
}) => {
  const response = await fetch(
    `${accountApiUrl}/data-sources/${dataSourceId}/cohorts?currentStep=RESULTS&includeStepsDetails=false`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  return await response.json();
};

export const getCohorts = async ({ token }: { token: string }) => {
  const response = await fetch(
    `${accountApiUrl}/data-sources/cohorts?currentStep=RESULTS&includeStepsDetails=false`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  return await response.json();
};

export const getCohortById = async ({
  token,
  dataSourceId,
  cohortId,
}: {
  token: string;
  dataSourceId: string;
  cohortId: string;
}) => {
  const response = await fetch(`${accountApiUrl}/data-sources/${dataSourceId}/cohort/${cohortId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  return await response.json();
};

export const updateCohort = async ({
  token,
  cohortToUpdate,
}: {
  token: string;
  cohortToUpdate: Partial<Cohort>;
}) => {
  const response = await fetch(
    `${accountApiUrl}/data-sources/${cohortToUpdate.dataSourceId}/cohort/${cohortToUpdate.cohortId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      method: 'PATCH',
      body: JSON.stringify(cohortToUpdate),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  const data = await response.json();

  return data;
};

export const cohortOrganizationUnitSync = async ({
  dataSourceId,
  cohortId,
  organizationUnitIds,
  token,
}: {
  dataSourceId?: string;
  cohortId?: string;
  organizationUnitIds: string[];
  token: string;
}) => {
  const [error, response] = await to(
    patch(
      `${DATA_SOURCE_BASE_URL}/${dataSourceId}/cohort/${cohortId}/organization-units/sync`,
      {
        organizationUnitIds,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    ),
  );

  if (error) {
    throw new Error(error);
  }

  return response;
};

export const getOrganizationUnitsByCohortId = async ({
  dataSourceId,
  cohortId,
  token,
}: {
  dataSourceId: string;
  cohortId: string;
  token: string;
}) => {
  const [error, response] = await to(
    get(`${DATA_SOURCE_BASE_URL}/${dataSourceId}/cohort/${cohortId}/organization-units`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
  if (error) {
    throw new Error(error);
  }
  return response;
};
